import { render, staticRenderFns } from "./BoardNeu.vue?vue&type=template&id=6f105e38&scoped=true"
import script from "./BoardNeu.vue?vue&type=script&lang=js"
export * from "./BoardNeu.vue?vue&type=script&lang=js"
import style0 from "./BoardNeu.vue?vue&type=style&index=0&id=6f105e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f105e38",
  null
  
)

export default component.exports